export default __webpack_public_path__ + "static/media/California.c68f599f.jpg";